import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    description: 'ship from step title',
    defaultMessage: 'Set a Ship From location {emoji}',
    id: 'B98+M7',
  },
  description: {
    description: 'ship from step description',
    defaultMessage:
      'You can ship from many locations, but buying a label requires starting from somewhere. Enter one, or as many addresses you ship from.',
    id: 'zblbYd',
  },
  addMessage: {
    description: 'add ship from button text',
    defaultMessage: 'Set Ship From Location',
    id: 'o1dWMY',
  },
  addAnotherMessage: {
    description: 'add another button link text',
    defaultMessage: 'Add another location',
    id: 'JZI/Vs',
  },
  connected: {
    description: 'connected ship from address',
    defaultMessage: '{line1} {city} {state}, {postal}',
    id: 'ky1tKd',
  },
  saveSuccessMessage: {
    description: 'ship from save success growler message',
    defaultMessage: 'Ship From saved successfully',
    id: 'Ocvj/w',
  },
});

export default messages;
